export default "__VITE_ASSET__DVAvm$Vg__"